import { SocialProvider } from '@/constants/xsolla';

enum FrameEvent {
  LOGIN = 'login',
  LOGOUT = 'logout',
  LANG_CHANGED = 'langChanged',
  GTM_EVENT = 'gtmEvent',
  LINK_SOCIAL = 'linkSocial',
  ORIGIN_ID_CHANGED = 'originIdChanged',
  RELOAD_FRAME = 'reloadFrame',
}

interface RequestEventParams {
  requestId: string;
}

interface LinkSocialParams extends RequestEventParams {
  provider: 'fb';
}

type LangChangedParams = {
  langId: string;
};

type GTMEventParams = {
  eventName: string;
  params?: object;
};

type OriginIdChangedParams = {
  originId: string;
};

const PROVIDERS: Record<string, string> = {
  fb: SocialProvider.FACEBOOK,
};

export {
  FrameEvent,
  RequestEventParams,
  LangChangedParams,
  GTMEventParams,
  LinkSocialParams,
  OriginIdChangedParams,
  PROVIDERS,
};
